<template>
  <v-card
    v-if="inspection && inspection.id"
    outlined
    max-width="400"
    class="mb-5"
  >
    <v-card-subtitle>
      <InspectionButtons :inspection="inspection" />
      <v-divider />
      <InspectionResult :inspection="inspection" />
    </v-card-subtitle>
    <v-divider />
    <v-card-text>
      <InspectionCommentField :inspection="inspection" />
      <v-divider />
      <InspectionFeedbackField :inspection="inspection" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import InspectionResult from './inspections/InspectionResult'
import InspectionButtons from './inspections/InspectionButtons'
import InspectionCommentField from './inspections/InspectionCommentField'
import InspectionFeedbackField from './inspections/InspectionFeedbackField'

export default {
  components: {
    InspectionResult,
    InspectionButtons,
    InspectionCommentField,
    InspectionFeedbackField
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      inspection: (state) => {
        if (state.PostEditor.post.recentOrder) {
          return state.PostEditor.post.recentOrder.currentActiveInspection
        } else {
          return null
        }
      },
      mode: (state) => state.PostEditor.mode
    })
  }
}
</script>
